(function(){
  function init(){
    var openBtn=document.querySelector('[data-cfs-stable-menu-open]');
    var closeBtn=document.querySelector('[data-cfs-stable-menu-close]');
    var drawer=document.querySelector('[data-cfs-stable-drawer]');
    var overlay=document.querySelector('[data-cfs-stable-overlay]');
    if(!openBtn||!drawer||!overlay)return;
    function open(){
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
      overlay.hidden=false; openBtn.setAttribute('aria-expanded','true'); document.documentElement.classList.add('cfs-stable-menu-open');
    }
    function close(){
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
      overlay.hidden=true; openBtn.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('cfs-stable-menu-open');
    }
    openBtn.addEventListener('click',open);
    if(closeBtn)closeBtn.addEventListener('click',close);
    overlay.addEventListener('click',close);
    drawer.addEventListener('click',function(e){if(e.target.closest('a')) close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init); else init();
})();

/* CFS compact sticky mobile header after scroll. */
(function(){
  function initCompactHeader(){
    var header=document.querySelector('[data-cfs-stable-header]');
    if(!header||header.dataset.compactReady==='1')return;
    header.dataset.compactReady='1';
    var ticking=false;
    function update(){
      header.classList.toggle('is-compact',window.scrollY>90);
      ticking=false;
    }
    window.addEventListener('scroll',function(){
      if(!ticking){window.requestAnimationFrame(update);ticking=true;}
    },{passive:true});
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initCompactHeader);else initCompactHeader();
  document.addEventListener('shopify:section:load',initCompactHeader);
})();
